export default __webpack_public_path__ + "static/media/iconfinder_cat.fc0f54af.png";